import { lazy } from 'react';

export const TeacherAssignmentDetailsPage = lazy(() => import('./TeacherAssignmentDetailsPage'));
